import { ClubPay } from './ClubPay';

export default ClubPay;
